export default function MySQL_PERIOD_DIFF() {
  return (
    <div>
      <h2>MySQL_PERIOD_DIFF</h2>    </div>
  );
}